import { clone, equals } from "ramda";

/**
 * @param record any
 * @param key string
 * pass an object as record and string with "." to access nested fields of that record
 */
export const getRecordFieldValue = (record: any, key: string) => {
  const keys = key.split(".");
  if (!keys.length) return record[key];
  return keys.reduce(function (acc, key) {
    return acc[key];
  }, record);
};

export const areEqual = (prevProps: any, nextProps: any) => {
  return equals(prevProps, nextProps);
};

export const upperCaseFirstLetter = (text: string): string => {
  return text[0].toUpperCase() + text.slice(1);
};

export const getMidNightDate = (date = new Date(), hours = 0): Date => {
  let clonedDate = clone(date);
  clonedDate.setHours(hours, 0, 0, 0);
  return clonedDate;
};

export const getRandomDarkColor = (): string => {
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += Math.floor(Math.random() * 10);
  }
  return color;
};

export const truncateText = (str: string, maxLen = 30, separator = " ") => {
  if (str.length <= maxLen) return str;
  return str.slice(0, str.lastIndexOf(separator, maxLen)) + "...";
};

export const formFieldHasError = (meta: any) => meta.touched && (meta.error || meta.submitError);

export const qar = Intl.NumberFormat("en-QA", { style: "currency", currency: "qar" }).format;
export const withPercent = (number: number) =>
  Intl.NumberFormat("en-US", {
    style: "percent",
  }).format(number / 100);
